import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { BigTitle } from "../components/typography/Typogtaphy";
import { CardsCollectionEarnLiquidityPool } from "../components/utils/CardsCollection";
import { actionCreators } from "../state";
import { BackButton } from "../components/light/LightButton";
import { TabTitle } from "../components/typography/Typogtaphy";
import { isLogged } from "../functions/session";

export default function EarnRoute(props: any): JSX.Element {

    const dispatch = useDispatch()
    const actions = bindActionCreators(actionCreators, dispatch)
    const [lpList, setLpList] = useState([])
    const [hideCards, setHideCards] = useState<number[]>([])
    const [activeTab, setActiveTab] = useState<boolean[]>([true, false, false, false, false])
    const [category, setCategory] = useState<string>("All")

    const logged = isLogged()

    useEffect(() => {
        actions.getAllLiquidityPools(setLpList)
    }, [])

    function changeView(category: string, id: number) {
        setCategory(category)
        let tmp = category === "All" ? [] : (
            lpList.map((lp: any, i) => {
                return lp.asset_a_category !== category ? i : -1
            })
        )
        tmp.filter((n) => n !== -1)
        setHideCards(tmp)
        var tmp2 = activeTab
        tmp2 = tmp2.map((_, i) => { return (i === id ? true : false) })
        setActiveTab(tmp2)
    }

    function Tab(props: { category: string, id: number }): JSX.Element {
        const cat = props.category === "INVESTMENT FUNDS" ? "IF" : props.category
        return <>
            <div onClick={() => { changeView(cat, props.id) }}
                className={"cursor-pointer mx-1 md:text-3xl " +
                    (activeTab[props.id] ? "text-succ8" : "")}>
                {props.category}</div>
        </>
    }

    return <>
        <div className="h-full px-2">
            <div className="w-full px-10 pb-2">
                <BigTitle title={"Earn"} color="succ8" />
            </div>
            <TabTitle className="flex place-content-center mt-8 gap-2 z-10 flex-wrap
                            mx-neg40 md:mb-6 ">
                <Tab category="All" id={0} />
                <Tab category="ART" id={1} />
                <Tab category="SPORTEX" id={2} />
                {logged ? (<Tab category="INVESTMENT FUNDS" id={3} />) : <></>}
                <Tab category="COLLECTABLES" id={4} />
            </TabTitle>
            <div>
                <CardsCollectionEarnLiquidityPool lpList={lpList} hide={hideCards} categoryName={category} />
            </div>
            <div className="flex justify-center mt-5">
                <BackButton />
            </div>
        </div>

    </>
}